import Typography from '@/common/components/base/typography/Typography';
import LoadingPage from '@/common/pages/LoadingPage';
import ComplaintImage from '@/modules/Statistics/assets/icons/complaint.svg?react';
import NoComplaintImage from '@/modules/Statistics/assets/icons/NoComplaint.svg?react';
import { useQuery } from '@tanstack/react-query';
import { Box, Flex } from 'styled-system/jsx';
import { getComplaintChartQueryOptions } from '../../queries/getComplaintChart/getComplaintChartQueryOptions';
import { getComplaintSummaryQueryOptions } from '../../queries/getComplaintSummary/getComplaintSummaryQueryOptions';
import RankingCard from '../card/RankingCard';
import BarChart from '../charts/BarChart';
import SatisfactionComplaint from './SatisfactionComplaint';

export default function StatisticComplaintSection() {
  const { data, isPending } = useQuery(getComplaintSummaryQueryOptions());

  const { data: ComplaintChartData, isPending: ComplaintChartPending } =
    useQuery(getComplaintChartQueryOptions());

  const labels = ComplaintChartData?.map((item) => item.month_name) ?? [];

  const values = ComplaintChartData?.map((item) => item.count ?? 0) ?? [];

  const hasNoComplaint = data?.total_count === 0;

  return (
    <Flex flexDirection="column">
      {isPending ? (
        <LoadingPage height="40vh" />
      ) : (
        <>
          <RankingCard
            rank={data?.total_count}
            label="شکایت"
            totalAssessors={data?.total_files}
            themeColor="red"
            icon={<ComplaintImage />}
          />

          {!hasNoComplaint && <SatisfactionComplaint data={data} />}
        </>
      )}

      {hasNoComplaint ? (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
          py="24px"
          gap="4px"
        >
          <NoComplaintImage />
          <Typography textStyle="b1" color="black" fontWeight="bold">
            خدمتِ بی‌نقص
          </Typography>
          <Typography textStyle="b1" color="black">
            عدم دریافت هرگونه شکایت و حفظ رضایت کامل{' '}
          </Typography>
        </Box>
      ) : ComplaintChartPending ? (
        <LoadingPage height="20vh" />
      ) : (
        <BarChart
          labels={labels}
          values={values}
          theme={'red'}
          maxValues={values}
          integerValues
        />
      )}
    </Flex>
  );
}
